export default __webpack_public_path__ + "static/boyd-bc56c054af3d7215f091e3288d84fa6c.jpg";